import { CheckInDto, CreateCheckInDto, ModelEventDto } from '@careapp-group/ng-sdk';
import { BaseFilterType, CaEntityActionsFactory } from '../entity-state/entity-actions-factory';
import { createAction, props } from '@ngrx/store';

class EventActions extends CaEntityActionsFactory<ModelEventDto, unknown, unknown, BaseFilterType> {
  constructor() {
    super(`events`);
  }
}

export const Events = new EventActions();
